import gql from 'graphql-tag';

export const entityFragment = gql`
  fragment entityFragment on Entity {
    name
    logoUrl
    countryCode
    isDisableComment
    isEsignConsent
    documentDownload
    reminderExpirationDays
    registeredNumber
    currency
    isSigningWrite
    isSigningForward
    signRedirect
    isAutoComment
    timezone
  }
`;

export const themeFragment = gql`
  fragment themeFragment on Theme {
    name
    backgroundColor
    backgroundImage
    backgroundType
    textColor
    accentColor
    fontSize
    fontFamily
    customCss
    logoUrl
    signButtonText
  }
`;
